export function getDirtyValues<T extends Record<string, unknown>>(
  dirtyFields: Record<string, unknown>,
  allValues: T,
): Partial<T> {
  return Object.fromEntries(
    Object.keys(dirtyFields).map((key) => [key, allValues[key]]),
  ) as Partial<T>
}
